import { render, staticRenderFns } from "./collect_pdf.vue?vue&type=template&id=4f8cce50&"
import script from "./collect_pdf.vue?vue&type=script&lang=js&"
export * from "./collect_pdf.vue?vue&type=script&lang=js&"
import style0 from "./collect_pdf.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports